const TokenKey = 'huli_token'
const Grpid = 'huli_grpid'
const ComId = 'huli_comid'

// 单页面防止页面的刷新导致vuex里面的数据丢失，本地存储一份
export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

// 登录信息
export function getGrpid(val) {
  return localStorage.getItem(Grpid)
}

export function setGrpid(val) {
  return localStorage.setItem(Grpid, val)
}

export function removeGrpid() {
  return localStorage.removeItem(Grpid)
}

export function getComId(val) {
  return localStorage.getItem(ComId)
}

export function setComId(val) {
  return localStorage.setItem(ComId, val)
}

export function removeComId() {
  return localStorage.removeItem(ComId)
}



// WEBPACK FOOTER //
// ./src/tool/auth.js